import React, { FC } from 'react'

import { IconName } from 'Components/Icon'
import SidebarNavigation, { NavigationItem } from 'Components/SidebarNavigation/SidebarNavigation'
import { routes } from 'Config/routes'

const navigationItems: NavigationItem[] = [
  {
    icon: IconName.utensils,
    label: 'Mein Essen',
    target: routes.myEatables.index
  },
  {
    icon: IconName.heart,
    label: 'Favoriten',
    target: routes.myEatables.favoritesOverview
  },

  {
    icon: IconName.plus,
    label: 'Nahrungsmittel erstellen',
    target: routes.myEatables.myFoodCreate
  },
  {
    icon: IconName.plus,
    label: 'Rezept erstellen',
    target: routes.myEatables.myRecipeCreate
  }
]

const SidebarUserFood: FC = () => {
  return (
    <div className="col-12 col-lg-4">
      <SidebarNavigation navigationItems={navigationItems} />
    </div>
  )
}

export default SidebarUserFood
